
        // Code to execute after UIManager is ready
        window.addEventListener('uiManagerReady', () => {
            // Handle refresh button click
            document.getElementById('refresh-button').addEventListener('click', async () => {
                const refreshButton = document.getElementById('refresh-button');
                console.log('Refresh button clicked!');
                
                // Add loading state
                refreshButton.classList.add('loading');
                refreshButton.disabled = true;
                console.log('Loading state applied, classes:', refreshButton.className);
                console.log('Button disabled:', refreshButton.disabled);
                
                try {
                    const hasUpdates = await window.uiManager.dataService.checkForUpdates();
                    if (hasUpdates) {
                        window.uiManager.showStatusMessage('הנתונים עודכנו בהצלחה', 'success');
                    } else {
                        window.uiManager.showStatusMessage('לא נמצאו עדכונים חדשים', 'info');
                    }
                } catch (error) {
                    console.error('Error checking for updates:', error);
                    window.uiManager.showStatusMessage('שגיאה בעדכון הנתונים', 'error');
                } finally {
                    // Remove loading state after longer delay to make it visible
                    setTimeout(() => {
                        refreshButton.classList.remove('loading');
                        refreshButton.disabled = false;
                        console.log('Loading state removed, classes:', refreshButton.className);
                        console.log('Button disabled:', refreshButton.disabled);
                    }, 2000);
                }
            });

            // Handle data updates
            window.addEventListener('dataUpdated', (event) => {
                const { timestamp } = event.detail;
                window.uiManager.updateLastUpdatedText(timestamp);
            });
            
            // Initialize auth buttons - make sure this happens after Firebase init
            import('./js/components/AuthButtons.js').then(module => {
                module.createAuthButtons('auth-container');
            }).catch(error => {
                console.error('Error loading auth buttons:', error);
            });
        });
    